export const BILLING_INFORMATION_SLICE_NAME = 'generalSettings/billingInformation';
